import { BranchList } from 'api/definitions/branchList/types';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';

import branchList from 'api/definitions/branchList';
import { GET_BRANCHES_LIST } from 'redux/modules/branches/actions/types';

const branchTypes = [
  'STANDARD_BRANCH',
  'LITTLE_WAITROSE',
  'MOTORWAY_SERVICES',
  'PETROL_STATIONS',
  'STANDARD_BRANCH_11',
  'CHANNEL_BRANCH',
  'JOHN_LEWIS_FOODHALL_FROM_WAITROSE',
];

export const getBranchesList = () => ({
  apiCall: branchList.get(),
  types: GET_BRANCHES_LIST.triplet,
  callback: {
    success: (res: BranchList) => {
      const filteredBranchesTypes = filter(res, ({ type }) => branchTypes.includes(type));
      const removeBranches = [865, 200, 579, 103, -9999];
      const filteredBranches = filter(
        filteredBranchesTypes,
        ({ id }) => !removeBranches.includes(id),
      );
      const branchesTransformed = filteredBranches.map(branch => ({
        ...branch,
        id: branch.id.toString(),
      }));
      return {
        branches: sortBy(branchesTransformed, 'name'),
      };
    },
  },
});
